import { render, staticRenderFns } from "./sheZhi.vue?vue&type=template&id=44b04307&scoped=true"
var script = {}
import style0 from "./sheZhi.vue?vue&type=style&index=0&id=44b04307&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b04307",
  null
  
)

export default component.exports